export default __webpack_public_path__ + "static/media/cain1.0602a321.jpg";